import React from "react";
import { Stack } from "@mui/material";
import { downloadBlobFile } from "../companies/BRECompanyHelpers";
import {
  deleteIncubatorLeaseDocument,
  downloadIncubatorLeaseDocument,
  uploadIncubatorLeaseDocument,
} from "./IncubatorAPI";
import CompanyDocumentsPanel from "../../../shared/components/CompanyDocumentsPanel";

const LEASE_DOCUMENT_LABELS = {
  description: "Upload one or more PDF lease documents for this incubator.",
  title: "Lease Documents",
  emptyMessage: "No lease documents uploaded yet.",
  invalidTypeMessage: "Lease document must be uploaded as a PDF.",
  uploadErrorMessage: "Failed to upload lease document.",
  downloadErrorMessage: "Failed to download lease document.",
  viewErrorMessage: "Failed to open lease document.",
  deleteErrorMessage: "Failed to delete lease document.",
  previewTitle: "Loading lease document...",
  defaultFileName: "lease-document.pdf",
  deleteButtonLabel: "Remove",
};

function IncubatorLeaseDocumentsTab({
  incubatorId,
  incubator,
  onIncubatorUpdated,
}) {
  return (
    <Stack spacing={2}>
      <CompanyDocumentsPanel
        companyId={incubatorId}
        documents={incubator?.lease_documents}
        uploadedAt={incubator?.lease_document_uploaded_at}
        labels={LEASE_DOCUMENT_LABELS}
        onUpload={uploadIncubatorLeaseDocument}
        onDownload={downloadIncubatorLeaseDocument}
        onDelete={deleteIncubatorLeaseDocument}
        onCompanyUpdated={onIncubatorUpdated}
        downloadBlobFile={downloadBlobFile}
      />
    </Stack>
  );
}

export default IncubatorLeaseDocumentsTab;
